import {
  Middleware,
  MiddlewareAPI,
  UnknownAction,
  ThunkDispatch,
} from '@reduxjs/toolkit'

import { sendNotification } from '../actions/notificationActions'
import { showAuthModal, setActionToReplay } from '../actions/authActions'

import type { RootState } from './configureStoreWithHistory'

type TypedDispatch = ThunkDispatch<RootState, any, UnknownAction>

type Store = MiddlewareAPI<TypedDispatch, RootState>

type Response = {
  data: any
  errors: Error[]
}

type FsaAction = {
  type: string
  error?: boolean
  payload?: any
  meta?: any
}

const isFsaAction = (value: unknown): value is FsaAction =>
  typeof value === 'object' && value !== null && 'type' in value

const handleErrorResponse = (store: Store, response: Response) => {
  const responseData = response.data
  if (!responseData) {
    return
  }

  if (responseData.errors) {
    store.dispatch(sendNotification(responseData.errors[0], 'error'))
  } else if (responseData.error) {
    store.dispatch(sendNotification(responseData.error, 'error'))
  }
}

type NetworkMiddleware = Middleware<{}, RootState, TypedDispatch>

const networkMiddleware: NetworkMiddleware = (store) => (next) => (action) => {
  if (
    isFsaAction(action) &&
    action.error &&
    action.payload &&
    action.payload.response
  ) {
    const { response } = action.payload
    const { auth } = store.getState()

    if (response.status === 422) {
      handleErrorResponse(store, response)
    } else if (response.status === 401) {
      if (action.meta && action.meta.auth === 'modal' && !auth.isSignedIn) {
        store.dispatch(setActionToReplay(action.meta.replay))
        store.dispatch(showAuthModal())
      } else {
        handleErrorResponse(store, response)
        const responseData = response.data
        if (responseData && responseData.action === 'redirect') {
          window.location.href = responseData.redirect_url
        }
      }
    } else {
      store.dispatch(sendNotification(response.message, 'error'))
    }
  }

  return next(action)
}

export default networkMiddleware
